export interface ApiResponse<T = unknown> {
  data: T;
  message?: string;
  success: boolean;
}

export interface ProblemDetails {
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  instance?: string;
}

export interface ApiConfig {
  baseURL: string;
  timeout?: number;
}

export class ApiError extends Error {
  status?: number;
  details?: ProblemDetails;

  constructor(message: string, status?: number, details?: ProblemDetails) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.details = details;
  }
}
